import * as z from "zod";

export const SupportV2TrueupResultSchema = z.object({
  openConvs: z.number(),
  matched: z.object({
    legacy: z.number(),
    provider: z.number(),
    content: z.number(),
    voice: z.number(),
  }),
  absent: z.number(),
  needsLegacyStamp: z.number(),
  writes: z.object({
    statusUpdated: z.number(),
    assigneeUpdated: z.number(),
    readUpdated: z.number(),
    tagsReconciled: z.number(),
    legacyStamped: z.number(),
  }),
  migration: z.object({
    inserted: z.number(),
    updated: z.number(),
    repaired: z.number(),
    skipped: z.number(),
    failed: z.number(),
  }),
  dryRun: z.boolean(),
});

export const getSupportV2TrueupResult = {
  name: "getSupportV2TrueupResult" as const,
  input: z.object({ workflowId: z.string() }).strict(),
  output: z.object({
    status: z.enum(["running", "completed", "failed", "cancelled", "unknown"]),
    result: SupportV2TrueupResultSchema.nullable(),
    error: z.string().nullable(),
  }),
};
